var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"logout-button"}},[_c('b-button',{staticClass:"inline-submenu-btn with_icon",on:{"click":function($event){return _vm.logout()}}},[_c('b-icon',{attrs:{"icon":"power","aria-hidden":"true"}}),_vm._v(" Déconnexion ")],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }